import WPMDBCommon from './src/js/helpers/wpmdbCommon';

window.wpmdb = {
	functions : {},
	common : {
		hooks: [],
		call_stack: [],
		non_fatal_errors: '',
		migration_error: false
	}
};

wpmdb.functions = new WPMDBCommon();

function importAll( require ) {
	require.keys().forEach( function( file ) {
		if ( !file.includes( 'wpmdbCommon.js' ) ) {
			require( file );
		}
	} );
}

importAll( 
	require.context( 
		'imports-loader?$=>window.jQuery!./src', true, /^(.*\.(js|sass|scss$))/im
	)
 );



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/webpack.index.js